/*
 * @Description:
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-03-15 20:29:37
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-03-15 20:31:10
 */
import { fetchGet } from "@/utils/request";

export default {
  //获取省份列表
  getProvinceList() {
    return fetchGet("/province/getList");
  },
  //获取城市列表
  getCityList(param) {
    return fetchGet("/city/getList", param);
  },
};
